import type { HttpClient } from 'utils/axios'
import type { LoadActionPayload } from './types'
import type { AxiosResponse } from 'axios'

export const loadData =
  (params: LoadActionPayload) =>
  (client: HttpClient): Promise<AxiosResponse> =>
    client.get(`user/${params.id}`)
